/**
 * Datos de configuración para cada tipo de campo
 *
 * Este archivo contiene la estructura de datos que define qué campos
 * mostrar en el modal de configuración para cada tipo de campo de entidad.
 */

import type { FieldConfigurations } from "./type";
import { phoneFieldConfiguration } from "./field-config-entries/phone";
import { identificationFieldConfiguration } from "./field-config-entries/identification";
import { fileFieldConfiguration } from "./field-config-entries/file";
import { selectFieldConfiguration } from "./field-config-entries/select";
import { localListFieldConfiguration } from "./field-config-entries/localList";

export const fieldConfigurationsData: FieldConfigurations = [
  phoneFieldConfiguration,
  identificationFieldConfiguration,
  fileFieldConfiguration,
  selectFieldConfiguration,
  localListFieldConfiguration,
];
